import React, { ComponentType } from 'react';
import { RenderElementProps } from 'slate-react';

export enum BlockTypes {
    h1 = "h1",
    h2 = "h2",
    h3 = "h3",
    h4 = "h4",
    h5 = "h5",
    h6 = "h6",

    ul = "ul",
    ol = "ol",
    li = "li",
    blockquote = "blockquote",
}

export const ParagraphElementType = "paragraph";

export type CustomBlockTypes = Record<string, React.ComponentType<RenderElementProps>>;

export interface BlockElementWithCustomBlocksProps extends RenderElementProps {
    customBlocks?: CustomBlockTypes;
    customRenderElement?: ComponentType<RenderElementProps>;
}

export const BlockElement = (props: BlockElementWithCustomBlocksProps) => {
    const { attributes, children, element } = props;
    const style = { textAlign: element.align };
    
    const CustomBlock = (props.customBlocks || {})[element.type];
    if(CustomBlock) {
        return <CustomBlock {...props} />
    }

    const CustomRenderElement = props.customRenderElement;
    if(CustomRenderElement) {
      return <CustomRenderElement {...props} />
    }

    switch(element.type) {
        case ParagraphElementType:
            return <p style={style} {...attributes}>{children}</p>
        default:
            const Wrapper = element.type as React.ElementType | string;
            if(Wrapper)
                return <Wrapper style={style} {...attributes}>{children}</Wrapper>;
            else
                return <></>;
    }

}
